"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Thrown when a password provided does meet the password policies
 */
class InvalidPasswordError extends client_library_1.ExtendableError {
    constructor() {
        super('The password provided is not valid');
    }
}
exports.default = InvalidPasswordError;
